import { render, staticRenderFns } from "./treasureList.vue?vue&type=template&id=ead7788c"
import script from "./treasureList.vue?vue&type=script&lang=js"
export * from "./treasureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports